import {
  TrendName,
  useGetListedCompanyTrendsQuery
} from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  name: TrendName;
  displayName: string;
}

export function useQuery() {
  const tuple = useGetListedCompanyTrendsQuery({
    variables: {
    }
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.listedCompanyTrends?.map((node) => ({
        id: node.id,
        name: node.name,
        displayName: node.displayName
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
